export var IngestionComputeSize;
(function (IngestionComputeSize) {
    IngestionComputeSize["INGESTION_COMPUTE_SIZE_XS"] = "XS";
    IngestionComputeSize["INGESTION_COMPUTE_SIZE_SMALL"] = "SMALL";
    IngestionComputeSize["INGESTION_COMPUTE_SIZE_MEDIUM"] = "MEDIUM";
    IngestionComputeSize["INGESTION_COMPUTE_SIZE_LARGE"] = "LARGE";
    IngestionComputeSize["INGESTION_COMPUTE_SIZE_XLARGE"] = "XLARGE";
})(IngestionComputeSize || (IngestionComputeSize = {}));
